<template>
  <p v-if="attr">
    <span class="b">{{ $t(this.translation) }}</span> {{ attr }}
  </p>
</template>

<script>
export default {
  name: "shopping-list-attribute",
  props: {
    translation: String,
    attr: String
  }
};
</script>
